import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => {
    const reduce = useReducedMotion();
    if (reduce) {
        return (
            <div className={className} {...rest}>
                {children}
            </div>
        );
    }
    return (
        <motion.div
            initial={{ opacity: 0, y, scale: 0.97 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
            className={className}
            {...rest}
        >
            {children}
        </motion.div>
    );
};

export const Overline = ({ children }) => (
    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold-600">{children}</p>
);
